function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var $596a1f0f523d6752$exports = require("./useDateFieldState.main.js");
var $1Q50t$internationalizeddate = require("@internationalized/date");
var $1Q50t$react = require("react");
var $1Q50t$reactstatelyutils = require("@react-stately/utils");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "useTimeFieldState", function () {
  return $2654e87be0231a69$export$fd53cef0cc796101;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $2654e87be0231a69$export$fd53cef0cc796101(props) {
  var _props$placeholderVal = props.placeholderValue,
    placeholderValue = _props$placeholderVal === void 0 ? new (0, $1Q50t$internationalizeddate.Time)() : _props$placeholderVal,
    minValue = props.minValue,
    maxValue = props.maxValue,
    granularity = props.granularity,
    validate = props.validate;
  var _props_defaultValue;
  var _ref = (0, $1Q50t$reactstatelyutils.useControlledState)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange),
    _ref2 = _slicedToArray(_ref, 2),
    value = _ref2[0],
    setValue = _ref2[1];
  var v = value || placeholderValue;
  var day = v && 'day' in v ? v : undefined;
  var defaultValueTimeZone = props.defaultValue && 'timeZone' in props.defaultValue ? props.defaultValue.timeZone : undefined;
  var placeholderDate = (0, $1Q50t$react.useMemo)(function () {
    var valueTimeZone = v && 'timeZone' in v ? v.timeZone : undefined;
    return (valueTimeZone || defaultValueTimeZone) && placeholderValue ? (0, $1Q50t$internationalizeddate.toZoned)($2654e87be0231a69$var$convertValue(placeholderValue), valueTimeZone || defaultValueTimeZone) : $2654e87be0231a69$var$convertValue(placeholderValue);
  }, [placeholderValue, v, defaultValueTimeZone]);
  var minDate = (0, $1Q50t$react.useMemo)(function () {
    return $2654e87be0231a69$var$convertValue(minValue, day);
  }, [minValue, day]);
  var maxDate = (0, $1Q50t$react.useMemo)(function () {
    return $2654e87be0231a69$var$convertValue(maxValue, day);
  }, [maxValue, day]);
  var timeValue = (0, $1Q50t$react.useMemo)(function () {
    return value && 'day' in value ? (0, $1Q50t$internationalizeddate.toTime)(value) : value;
  }, [value]);
  var dateTime = (0, $1Q50t$react.useMemo)(function () {
    return value == null ? null : $2654e87be0231a69$var$convertValue(value);
  }, [value]);
  var onChange = function onChange(newValue) {
    setValue(day || defaultValueTimeZone ? newValue : newValue && (0, $1Q50t$internationalizeddate.toTime)(newValue));
  };
  var state = (0, $596a1f0f523d6752$exports.useDateFieldState)(_objectSpread(_objectSpread({}, props), {}, {
    value: dateTime,
    defaultValue: undefined,
    minValue: minDate,
    maxValue: maxDate,
    onChange: onChange,
    granularity: granularity || 'minute',
    maxGranularity: 'hour',
    placeholderValue: placeholderDate !== null && placeholderDate !== void 0 ? placeholderDate : undefined,
    // Calendar should not matter for time fields.
    createCalendar: function createCalendar() {
      return new (0, $1Q50t$internationalizeddate.GregorianCalendar)();
    },
    validate: (0, $1Q50t$react.useCallback)(function () {
      return validate === null || validate === void 0 ? void 0 : validate(value);
    }, [validate, value])
  }));
  return _objectSpread(_objectSpread({}, state), {}, {
    timeValue: timeValue
  });
}
function $2654e87be0231a69$var$convertValue(value) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1Q50t$internationalizeddate.today)((0, $1Q50t$internationalizeddate.getLocalTimeZone)());
  if (!value) return null;
  if ('day' in value) return value;
  return (0, $1Q50t$internationalizeddate.toCalendarDateTime)(date, value);
}